import axiosHandler from '../axiosInterceptors';
import { INITIAL_LOAD_URL_DROPDOWN, INITIAL_LOAD_URL_FETCH_USER, INITIAL_LOAD_URL_FETCH_ROLE_AUTHORIZATION, USER_ACCESS_INFO } from '../constants/urls';
import setAuthHeader from './AuthHeader';
// Call the setAuthHeader function to set the Authorization header

export async function fetchDropdownList() {
    setAuthHeader();
    try{
        const resp = await axiosHandler.get(INITIAL_LOAD_URL_DROPDOWN);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function fetchLoggedInUser() {
    setAuthHeader();
    try{
        const resp = await axiosHandler.get(INITIAL_LOAD_URL_FETCH_USER);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function fetchRoleAuthorization() {
    setAuthHeader();
    try{
        const resp = await axiosHandler.get(INITIAL_LOAD_URL_FETCH_ROLE_AUTHORIZATION);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function fetchPageAuthorization() {
    setAuthHeader();
    try{
        const resp = await axiosHandler.get(USER_ACCESS_INFO);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}